import {
  isTextBackgroundCardGroup,
} from './annotationGroupUtils';

/**
 * Transformer border / handle colors by selection state.
 * Priority: locked (amber) > grouped (pink) > default (accent blue).
 */
export const SELECTION_TRANSFORMER_APPEARANCE = {
  default: {
    borderStroke: null,
    anchorStroke: null,
    anchorFill: null,
  },
  locked: {
    borderStroke: '#CA8A04',
    anchorStroke: '#CA8A04',
    anchorFill: '#FEF9C3',
  },
  grouped: {
    borderStroke: '#DB2777',
    anchorStroke: '#DB2777',
    anchorFill: '#FCE7F3',
  },
};

export const getSelectionTransformerState = (selectionsIds, annotations = {}) => {
  const ids = selectionsIds.filter((id) => annotations[id]);
  if (ids.length === 0) {
    return 'none';
  }
  if (ids.some((id) => annotations[id]?.locked)) {
    return 'locked';
  }
  if (
    ids.length === 1 &&
    ids[0] &&
    annotations[ids[0]]?.groupId &&
    isTextBackgroundCardGroup(annotations, annotations[ids[0]].groupId)
  ) {
    return 'default';
  }
  if (ids.some((id) => annotations[id]?.groupId)) {
    return 'grouped';
  }
  return 'default';
};

export const getSelectionTransformerAppearance = (
  selectionsIds,
  annotations,
  themePalette = {},
) => {
  const state = getSelectionTransformerState(selectionsIds, annotations);
  const accent = themePalette['accent-primary'] ?? '#3B82F6';
  const accentFill = themePalette['access-primary'] ?? '#FFFFFF';
  const preset = SELECTION_TRANSFORMER_APPEARANCE[state] ?? {};

  const borderStroke = preset.borderStroke ?? accent;
  const anchorStroke = preset.anchorStroke ?? accent;
  const anchorFill = preset.anchorFill ?? accentFill;
  const borderOnly = state === 'locked' || state === 'grouped';

  return {
    state,
    borderStroke,
    anchorStroke,
    anchorFill,
    borderOnly,
    resizeEnabled: !borderOnly,
    rotateEnabled: !borderOnly,
    showAnchors: !borderOnly,
  };
};
